
namespace RioERP.Masters {
    export class EmailTemplatesColumns {
        static columnsKey = 'Masters.EmailTemplates';
    }
}